
import { Header, Box, SpaceBetween, Button, ContentLayout } from '@cloudscape-design/components';
import { useTranslation } from "react-i18next";
// import { useNavigate } from 'react-router-dom';

const BaseLayout = (props) => {
        const { content } = props;
    const { t, i18n } = useTranslation();
    // const navigate = useNavigate()

    
  const toggleLang = () => {
    if (i18n.language === "ar") {
      i18n.changeLanguage("en")
      // populateValues()
    } else if (i18n.language === "en") {
      i18n.changeLanguage("ar")
      // populateValues()
    }
  }

    return (<ContentLayout
        defaultPadding
        headerVariant="high-contrast"
        headerBackgroundStyle="#5E5270"
        header={
            <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
                <Header
                    variant="h3"
                    description={t('subheader_logo')}
                    actions={
                        <SpaceBetween size="m">
                            <Box float="right">
                                <Button
                                    iconAlign="right"
                                    iconName="location-pin"
                                    onClick={toggleLang} variant="normal">{t("Switch Lanuage")}</Button>
                            </Box>
                            <Button href="https://ilaftakaful.com/" external variant="primary">{t("Official Website")}</Button>
                        </SpaceBetween>
                    }
                >
                    {/* src="/images/ilaf_transparent_logo.png" /> */}
                    <img alt="ILAF Takaful Insurance Company" width={150} src="/images/ilaf_logo_cc_.png" /> 
                    <br />
                    <br />
                    {t('header_logo')}
                </Header>
            </div>
        }
    >

        {content}

    </ContentLayout>)

}

export default BaseLayout;
